export const FirstAccountingDocumentType = Object.freeze({
    FISCAL_DOCUMENT: 'INVOICE',
    CASH_FLOW: 'CASHFLOW'
});
